import {FormControlLabel, Grid, IconButton, Input, InputLabel, RadioGroup, Typography,} from "@material-ui/core";
import React, {useEffect, useRef, useState} from "react";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import AddIcon from "@material-ui/icons/Add";
import CancelIcon from "@material-ui/icons/Cancel";
import {parseIntegerInputOrEmpty} from "../../../../../utils/forms/parseNumberInput";

export const translateTimeUnit = (timeUnit) => {
    //console.log(timeUnit);
    switch (timeUnit) {
        case "m":
            return "MINUTES";
        case "d":
            return "DAYS";
        case "w":
            return "WEEKS";
        case "M":
            return "MONTHS";
        case "q":
            return "QUARTERS";
        case "y":
            return "YEARS";
    }
};

export const timeUnits = ["m", "d", "w", "M", "q", "y"];

var runningNumber = 0;

export default function FTFCSetup({setupDetailTimeFrames, dispatchSetUpDetails}) {
    const [timeFrames, setTimeFrames] = useState(() => {
            const s = {};
            setupDetailTimeFrames.forEach(tf => {
                s[runningNumber++] = tf;
            });
            return s;
        })
    ;
    useEffect(() => {
        if (JSON.stringify(Object.values(timeFrames)) !== JSON.stringify(setupDetailTimeFrames)) {
            const s = {};
            setupDetailTimeFrames.forEach(tf => {
                s[runningNumber++] = tf;
            });
            setTimeFrames(s);
        }
    }, [setupDetailTimeFrames]);
    //console.log(setupDetailTimeFrames);
    return (
        <>
            {Object.keys(timeFrames).map((key) =>
                <TimeFrameUnit
                    key={key}
                    dispatchSetUpDetails={dispatchSetUpDetails}
                    index={key}
                    timeFrames={timeFrames}
                    timeFrame={timeFrames[key]}
                    setComponentTimeFrames={setTimeFrames}
                    //    listSize={listSize}
                    //  setListSize={setListSize}
                />
            )}
            <IconButton
                onClick={(ev) => {
                    timeFrames[runningNumber++] = {candleDuration: 1, timeUnit: ""}
                    setTimeFrames(timeFrames);
                    dispatchSetUpDetails(Object.values(timeFrames));

                }}
                style={{width: 1, height: 1}}
                size="small"
            >
                <AddIcon style={{color: "green"}}/>
            </IconButton>
        </>
    )
}

function TimeFrameUnit({
                           dispatchSetUpDetails,
                           timeFrame,
                           timeFrames,
                           index,
                           setComponentTimeFrames
                       }) {

    //let timeFrame = timeFrames[index];

    const [candleDurationTxt, setCandleDurationTxt] = useState(timeFrame.candleDuration)

    const [candleDuration, setCandleDuration] = useState(
        timeFrame.candleDuration !== undefined
            ? timeFrame.candleDuration
            : 1
    );
    const [timeUnit, setTimeUnit] = useState(
        timeFrame.timeUnit !== undefined
            ? timeFrame.timeUnit
            : ""
    );
    //console.log(timeFrame);
    useEffect(() => {
        timeFrame.candleDuration = candleDuration;
        timeFrame.timeUnit = timeUnit;
        dispatchSetUpDetails({timeFrames: Object.values(timeFrames)});
    }, [candleDuration, timeUnit]);

    useEffect(() => {
        setCandleDurationTxt(timeFrame.candleDuration);
    }, [timeFrame.candleDuration])
    //   console.log(candleDuration, timeUnit, index);
    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={1}>
                    <IconButton
                        size={"small"}
                        style={{width: 1, height: 1}}
                        onClick={(ev) => {
                            console.log("before delete: " + JSON.stringify(timeFrames));
                            delete timeFrames[index];
                            //    let deepCopy = {};
                            //  Object.keys(timeFrames).forEach(key => deepCopy[key] = timeFrames[key]);
                            //  console.log("after delete: " + JSON.stringify(timeFrames));
                            //  setComponentTimeFrames(deepCopy);
                            if (Object.keys(timeFrames).length === 0) {
                                dispatchSetUpDetails({timeFrames: []});
                            } else {
                                dispatchSetUpDetails({timeFrames: Object.values(timeFrames)});
                            }
                        }}
                    >
                        <CancelIcon
                            style={{color: "red", backgroundColor: "transparent", width: 15, height: 15}}
                        />
                    </IconButton>
                </Grid>
                <Grid item xs={1}>
                    <InputLabel>
                        <Typography style={{fontSize: 8}}>candle:</Typography>
                    </InputLabel>
                    <Input
                        size="small"
                        style={{height: 15, fontSize: 10, width: 20}}
                        value={candleDurationTxt}
                        onBlur={(ev) => setCandleDuration(parseIntegerInputOrEmpty(ev.target.value))}
                        onChange={(ev) => setCandleDurationTxt(ev.target.value)}
                    />
                </Grid>
                <Grid item xs={9}>
                    <RadioGroup
                        row
                        aria-label="timeUnit"
                        name="timeUnit"
                        value={timeUnit}
                        onChange={(ev) => {
                            //console.log(ev.target);
                            setTimeUnit(translateTimeUnit(ev.target.value));
                        }}
                    >
                        {timeUnits.map((tu) => {
                            //console.log(tu);
                            return (
                                <Grid item xs={2} key={tu + "g"}>
                                    <FormControlLabel
                                        key={tu + "c"}
                                        value={tu}
                                        checked={translateTimeUnit(tu) === timeUnit}
                                        labelPlacement="bottom"
                                        control={<StyledRadio/>}
                                        label={
                                            <Typography style={{fontSize: 8}}>{tu}</Typography>
                                        }
                                    />
                                </Grid>
                            );
                        })}
                    </RadioGroup>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
